import React from 'react'

export const DOWNLOAD_START_TIMER = (time) => {
    return <React.Fragment><span>Прошло времени: &nbsp;</span>{time}</React.Fragment>
} //<React.Fragment><span>Прошло времени: &nbsp;</span><mark id="download_timer"></mark><span>&nbsp;секунд</span></React.Fragment>

export const DOWNLOAD_FINISH_TIMER = <React.Fragment><span>Скачивание начнется через&nbsp;</span><mark id="download_timer"></mark><span>&nbsp;секунд</span></React.Fragment>

export const DOWNLOAD_START_MAIN = <React.Fragment><span>Идет подготовка к скачиванию, пожалуйста подождите...</span></React.Fragment>

export const DOWNLOAD_INFO_FILES = `Подготавливаем файлы...`
export const DOWNLOAD_INFO_ZIP = `Формируем архив...`
export const DOWNLOAD_INFO_LOAD = `Готовим архив к загрузке...`
export const DOWNLOAD_INFO_HALF_TIME_10s = `Еще чуть-чуть...`
export const DOWNLOAD_INFO_HALF_TIME_20s = `Почти готово...`
export const DOWNLOAD_INFO_HALF_TIME_30s = `Это занимает немножко больше времени, чем мы думали...`
export const DOWNLOAD_INFO_HALF_TIME_TANK_ADVICE = `Танковый совет: `
export const DOWNLOAD_INFO_HALF_TIME_40s = `прочитай подсказку перед выполнением задачи – это сэкономит время!`
export const DOWNLOAD_INFO_HALF_TIME_50s = `не продавай танки, которые тебе нравятся.`
export const DOWNLOAD_INFO_HALF_TIME_60s = `техника разных уровней пригодится для выполнения задач, которые принесут ценные ресурсы.`
export const DOWNLOAD_INFO_HALF_TIME_70s = `ты можешь собрать свою уникальную коллекцию машин, превратив ангар в настоящий музей военной техники!`
export const DOWNLOAD_INFO_HALF_TIME_80s = `если ты новичок - воспользуйся уникальным промокодом, который даст возможность почувствовать себя уверенее!`
export const DOWNLOAD_INFO_HALF_TIME_90s = `заканчивается "серебро" - поиграй на премиум технике.`
export const DOWNLOAD_INFO_HALF_TIME_100s = `коллекционная техника не приносит дополнительных бонусов, в отличии от премиум машин.`
//export const DOWNLOAD_INFO_HALF_TIME_110s = `Инфо:...`
//export const DOWNLOAD_INFO_HALF_TIME_120s = `Инфо:...`
export const DOWNLOAD_INFO_GREAT = `Файл готов`
export const DOWNLOAD_INFO_GREAT_AND_LOAD = `Начинается скачивание!`

export const DOWNLOAD_ATTENTION = <React.Fragment>Обращаем Ваше внимание на то, что <mark>компания Lesta не несёт ответственности</mark> за использование модификаций.</React.Fragment>

export const DOWNLOAD_ALERT = "Выбранная версия мода не соответствует актуальной версии игры."

export const AUTODOWNLOAD_CLICK = `Если автоматическое скачивание не произошло, нажмите`
export const HERE_CLICK = `здесь`

export const DOWNLOAD_DIR = (fileName) => {
    return `https://tankimods.net/media/mod_files/${fileName}`
}